(() => {
  const sliders = new Map();

  const toBoolean = (value) => value === 'true';

  const mountSlider = (container) => {
    if (!window.Splide || sliders.has(container)) return;

    const splideElement = container.querySelector('.splide');
    if (!splideElement) return;

    const slideCount = splideElement.querySelectorAll('.splide__slide').length;
    const effect = container.dataset.effect === 'fade' ? 'fade' : 'loop';
    const isOriginalHeight = container.classList.contains('hero-slider--original');

    const isAutoplay = slideCount > 1 && toBoolean(container.dataset.autoplay);

    const splide = new Splide(splideElement, {
      type: slideCount > 1 ? effect : 'slide',
      rewind: effect === 'fade',
      autoplay: isAutoplay,
      interval: Number(container.dataset.interval) || 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: slideCount > 1 && toBoolean(container.dataset.pagination),
      speed: 800,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: slideCount > 1,
      keyboard: 'focused',
      autoHeight: isOriginalHeight,
    });

    if (isAutoplay) {
      splide.on('mounted', () => {
        splide.Components.Autoplay?.play();
      });
    }

    splide.mount();
    sliders.set(container, splide);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-hero-slider]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    const splide = sliders.get(container);
    if (!splide) return;

    splide.destroy(true);
    sliders.delete(container);
  };

  document.addEventListener('DOMContentLoaded', () => mountAll());

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-hero-slider]').forEach(destroySlider);
  });
})();
